import getAlbums from "app/api/requests/Gallery/getAlbums";
import deleteAlbum from "app/api/requests/Gallery/deleteAlbum";
import putAlbum from "app/api/requests/Gallery/putAlbum";
import putResource from "app/api/requests/Gallery/putResource";
import deleteResource from "app/api/requests/Gallery/deleteResource";

export default {
	getAlbums,
	deleteAlbum,
	putAlbum,
	putResource,
	deleteResource
}
